module.exports = __webpack_public_path__ + "static/img/20261104_3.7420bd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/20261104_3.jpg
// module id = h+Xj
// module chunks = 98